<template>
  <page-header-wrapper>
    <div class="sms-package-page">
      <!-- 标题区域 -->
      <div class="page-header">
        <h1 class="page-title">短信套餐包</h1>
        <p class="page-subtitle">
          选择适合您的短信套餐包，享受优惠价格。套餐内短信条数越多，单条价格越低。购买后立即生效。
        </p>
      </div>

      <!-- 套餐卡片区域 -->
      <div class="package-cards">
        <a-spin :spinning="loading" tip="正在加载套餐信息...">
          <a-row :gutter="[24, 24]" v-if="packageList.length > 0">
            <a-col
              v-for="(item, index) in packageList"
              :key="index"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              :xl="8"
            >
              <div
                class="package-card"
                :class="{
                  'package-recommended': item.recommended,
                  'selected-package': selectedPackageId === item.title
                }"
                @click="selectPackage(item)"
              >
                <div v-if="item.recommended" class="recommended-badge">推荐</div>
                <div v-if="selectedPackageId === item.title" class="selected-badge">已选择</div>

                <div class="card-header">
                  <h3 class="package-name">{{ item.title }}</h3>
                  <div class="package-price">
                    <span class="price-symbol">¥</span>
                    <span class="price-number">{{ item.totalPrice.replace('¥', '') }}</span>
                    <span class="price-period"> / 套餐</span>
                  </div>
                </div>
                <div class="card-content">
                  <p class="package-description">{{ item.description }}</p>
                  <div class="feature-list">
                    <div class="feature-item">
                      <span>{{ item.count }}</span>
                    </div>
                    <div class="feature-item">
                      <span>{{ item.unitPrice }}/条</span>
                    </div>
                    <div class="feature-item">
                      <span>{{ getValidDaysText(item.validDays) }}</span>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <a-button type="primary" class="purchase-button" @click.stop="handleBuy(item)">立即购买</a-button>
                </div>
              </div>
            </a-col>
          </a-row>
          <a-empty v-else description="暂无套餐数据" style="margin: 40px 0;" />
        </a-spin>
      </div>

    </div>
    <PaymentModal ref="paymentModal" @payment-success="handlePaymentSuccess" />
  </page-header-wrapper>
</template>

<script>
import PaymentModal from './modules/PaymentModal.vue'
import { fetchPackageList } from '@/api/sms/packageList'
import events from '@/components/MultiTab/events'

export default {
  name: 'SmsPackage',
  components: {
    PaymentModal,
  },
  data() {
    return {
      selectedPackageId: null,
      packageList: [],
      loading: false,
    }
  },
  methods: {
    // 格式化价格，去掉末尾不必要的0
    formatPrice(price, decimals = 4) {
      const num = Number(price)
      if (isNaN(num)) return '¥0'
      // 先保留指定小数位，然后使用 parseFloat 去掉末尾的0
      const fixed = num.toFixed(decimals)
      return `¥${parseFloat(fixed)}`
    },
    async getPackageList() {
      this.loading = true
      try {
        const response = await fetchPackageList()
        if (response.success && response.data) {
          this.packageList = response.data
            .sort((a, b) => (a.sort || 0) - (b.sort || 0))
            .map((item, index) => ({
              id: item.id,
              title: item.packageName,
              description: item.description || '优质短信服务套餐',
              unitPrice: this.formatPrice(item.unitPrice, 4),
              totalPrice: `¥${Number(item.price).toFixed(2)}`,
              count: `${item.smsCount}条短信`,
              validDays: item.validDays || 0,
              buttonText: '立即购买',
              recommended: null,
              originalData: item,
            }))
        } else {
          this.$message.error('获取套餐列表失败')
          this.packageList = []
        }
      } catch (error) {
        console.error('获取套餐列表失败:', error)
        this.$message.error('获取套餐列表失败')
        this.packageList = []
      } finally {
        this.loading = false
      }
    },

    selectPackage(item) {
      if (this.selectedPackageId === item.title) {
        this.selectedPackageId = null
      } else {
        this.selectedPackageId = item.title
      }
    },

    handleBuy(item) {
      const purchaseData = {
        title: item.title,
        count: item.count,
        totalPrice: item.totalPrice,
        validDays: item.validDays,
        originalData: item.originalData,
      }
      this.$refs.paymentModal.show(purchaseData)
    },

    handlePaymentSuccess(paymentResult) {
      this.$message.success('购买成功！短信服务已开通')
      this.$router.go(-1)
      const pages = this.$store.pages
      events.$emit('close', pages.indexOf(this.$route))
    },

    getValidDaysText(validDays) {
      if (!validDays || validDays === 0) {
        return '有效期 永久有效'
      }

      if (validDays >= 365) {
        const years = Math.floor(validDays / 365)
        return `有效期 ${years}年`
      } else if (validDays >= 30) {
        const months = Math.floor(validDays / 30)
        return `有效期 ${months}个月`
      } else {
        return `有效期 ${validDays}天`
      }
    },
  },
  mounted() {
    this.getPackageList()
  },
}
</script>

<style lang="less" scoped>
.sms-package-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 24px 60px;
  background: #f5f5f5;
  min-height: calc(100vh - 64px);

  // 标题区域
  .page-header {
    text-align: center;
    margin-bottom: 60px;
    padding-top: 20px;

    .page-title {
      font-size: 36px;
      font-weight: 700;
      margin-bottom: 20px;
      color: #262626;
      letter-spacing: 0.5px;
    }

    .page-subtitle {
      font-size: 16px;
      color: #595959;
      line-height: 1.8;
      margin: 0 auto;
      max-width: 800px;
    }
  }

  // 套餐卡片区域
  .package-cards {
    margin-bottom: 80px;

    /deep/ .ant-row {
      display: flex;
      flex-wrap: wrap;
      margin-left: -12px;
      margin-right: -12px;
    }

    /deep/ .ant-col {
      display: flex;
      flex-direction: column;
      padding-left: 12px;
      padding-right: 12px;
      margin-bottom: 24px;
    }

    .package-card {
      background: #ffffff;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      padding: 24px;
      height: 100%;
      display: flex;
      flex-direction: column;
      transition: all 0.3s ease;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      min-height: 400px;
      position: relative;
      margin-bottom: 20px;
      cursor: pointer;

      /deep/ .ant-card-body {
        padding: 32px 24px 24px;
        height: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
      }

      &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        transform: translateY(-4px);
      }

      &.popular-package {
        border: 2px solid #4F46E5;
        position: relative;
        overflow: hidden;
      }

      &.package-recommended {
        border: 2px solid #1890ff;
        box-shadow: 0 4px 16px rgba(24, 144, 255, 0.15);

        &:hover {
          box-shadow: 0 6px 20px rgba(24, 144, 255, 0.2);
        }
      }

      &.selected-package {
        border: 2px solid #4F46E5;
        background: #f0f8ff;
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(79, 70, 229, 0.15);
      }

      .recommended-badge {
        position: absolute;
        top: -1px;
        right: -1px;
        background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
        color: #fff;
        padding: 8px 20px;
        border-radius: 0 12px 0 20px;
        font-size: 13px;
        font-weight: 600;
        z-index: 10;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
        letter-spacing: 0.5px;
        line-height: 1.5;
      }

      .popular-badge {
        position: absolute;
        top: 0;
        right: 0;
        background-color: #4F46E5;
        color: white;
        padding: 4px 8px;
        font-size: 12px;
        border-radius: 0 8px 0 8px;
        z-index: 1;
      }

      .selected-badge {
        position: absolute;
        top: 0;
        left: 0;
        background-color: #52c41a;
        color: white;
        padding: 4px 8px;
        font-size: 12px;
        border-radius: 8px 0 8px 0;
        z-index: 1;
      }

      .card-header {
        text-align: center;
        margin-bottom: 20px;
        border-bottom: 1px solid #f0f0f0;
        padding-bottom: 20px;
      }

      .package-name {
        font-size: 20px;
        font-weight: 600;
        color: #262626;
        margin-bottom: 12px;
        line-height: 1.4;
      }

      .card-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      .package-description {
        font-size: 14px;
        color: #666666;
        line-height: 1.6;
        margin: 0;
        min-height: 44px;
        display: flex;
        align-items: center;
        padding: 8px 0;
        transition: min-height 0.2s ease;
      }

      .feature-list {
        display: flex;
        flex-direction: column;
        margin-top: 8px;
      }

      .feature-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: #262626;
        line-height: 1.5;
      }

      .card-footer {
        margin-top: 24px;
        text-align: center;
      }

      .package-price {
        display: flex;
        align-items: baseline;
        justify-content: center;
        gap: 2px;
      }

      .price-symbol {
        font-size: 16px;
        color: #ff4d4f;
        font-weight: 500;
      }

      .price-number {
        font-size: 32px;
        color: #ff4d4f;
        font-weight: 600;
        line-height: 1;
      }

      .price-period {
        font-size: 14px;
        color: #666666;
      }

      .package-count {
        font-size: 16px;
        color: #262626;
        margin-bottom: 24px;
        font-weight: 500;
        line-height: 1.5;
        flex-shrink: 0;
      }

      .purchase-button {
        width: 100%;
        height: 40px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 6px;
        background: #4F46E5;
        border-color: #4F46E5;
        box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
      }

      .purchase-button:hover,
      .purchase-button:focus {
        background: #4F46E5;
        border-color: #4F46E5;
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(24, 144, 255, 0.3);
      }

    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .sms-package-page {
    padding: 24px 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-description {
    font-size: 14px;
  }

  .package-cards .ant-col {
    margin-bottom: 24px;
  }

  .package-name {
    font-size: 18px;
  }

  .price-number {
    font-size: 28px;
  }
}
</style>
